/*
 * @Author: your name
 * @Date: 2021-09-20 10:54:02
 * @LastEditTime: 2021-12-07 18:31:54
 * @LastEditors: sueRimn
 * @Description: In User Settings Edit
 * @FilePath: \Bounty\src\i18n\lang\en\index.js
 */
import enLocale from 'element-ui/lib/locale/lang/zh-CN'

export default {
  Index: {
    wallet: '连接钱包',
    title1: 'Earn',
    title2: 'Bounties',
    title3: 'By Doing Tasks',
    getStart: '立即开始',
    donotHave: '没有钱包',
    copyRight: '© 2021 Conflux. All Rights Reserved. Terms Privacy | Policy',
    header: {
      walletTip: '未安装钱包'
    },
    footer: {
      FAQs: 'FAQs',
      Conflux: 'Conflux',
      Explorer: 'Explorer',
      Wallet: 'Wallet',
      BountyV1: 'Bounty V1',
      Help: 'Help'
    },
    bannerDes1: 'Bounty操作指南',
    bannerDes2: '绑定PandaID领取CFX'
  },
  Router: {
    Skills: '技能',
    HotTask: '热门任务',
    AllTask: '全部任务',
    Projects: '项目'
  },
  Skills: {
    title: '技能',
    description: '获得技能以探索更多任务',
    backDes: '全部任务',
    startTask: '开始任务',
    helpDescription: '技能是一种链上凭证，表示您对某个给定主题或产品的了解。',
    skilPandaId: {
      tip: '系统检测到您的Panda ID未进行身份验证。点击跳转验证身份。',
      tip2: '系统检测到您的Panda ID未进行身份验证。',
      No: '关闭',
      Yes: '去验证'
    },
    skilPortal: {
      tip: '钱包未连接',
      No: '关闭',
      Yes: '去安装'
    },
    skillListTip: {
      tipPortal: '安装Portal',
      desPortal: '安装Portal Wallet',
      tipPandaId: '安装Panda ID',
      desPandaId: '已经绑定Panda ID？',
      checkNow: '检查'
    }
  },
  HotTask: {
    title: '热门任务',
    description: '获取技能以探索更多任务',
    all: '全部',
    personal: '个人',
    project: '项目',
    backDes: '热门任务',
    titleDetail: '任务',
    descriptionDetail: '从PoolGo开始',
    taskStatus: ['正在进行中', '即将开始', '已完成'],
    Rewards: '奖励',
    Remaining: '余额',
    rewardsRemaining: '奖励余额',
    totalRewards: '总奖励',
    issued: '已发放',
    participants: '参与人数',
    Ends: '结束时间 ',
    detail: {
      Description: '描述',
      AcceptanceCriteria: '验收准则',
      ContactInformation: '联系方式',
      About: '大约剩余 ',
      HoursLeft: ' 小时'
    },
    StartTask: '开始任务',
    NoData: '无数据'
  },
  planDialog: {
    RejectReason: '原因',
    ProgrammeDetails: '解决方案',
    Completion: '完成',
    CompleteAttachment: '完成附件',
    Cancel: '取消',
    Submit: '提交',
    SubmitToCheck: '提交以确认'
  },
  AllTask: {
    title: '全部任务',
    description: '获取技能以探索更多任务',
    backDes: '全部任务',
    searchPlaceholder: '根据任务编号或关键词搜索',
    TotalReward: '奖励总额: ',
    taskStatus: {
      Ongoing: '正在进行中',
      Upcoming: '即将开始',
      Finished: '已完成'
    }
  },
  ...enLocale,
  My: {
    My: '我的',
    BountyName: 'Bounty name',
    EditProfile: '编辑个人信息',
    Nickname: '昵称',
    PandaID: 'Panda ID',
    Email: 'Email',
    PandaState: 'PandaId认证状态',
    IdentityCategories: '身份类别',
    NoteInformation: '信息',
    HeadPortrait: '头像',
    Save: '保存',
    message: {
      title: '消息',
      subTitle: '任务',
      removeUnread: '清除未读',
      ClearAllNotice: '清除全部通知',
      yes: '确认',
      cancel: '关闭'
    },
    project: {
      CreationTime: '创建时间:'
    },
    loading: '上传中',
    approving: '授权中',
    approveBtn: '授权',
    view: '在线预览'
  },
  MyList: {
    MyProject: '我的项目',
    publishedTasks: '已发布的任务',
    receivedScheme: '已收到的方案',
    submittedProposal: '已提交的提案',
    MissionName: '任务名称',
    ReleaseTime: '发布时间',
    TheNumberOfparticipants: '参与者人数',
    Operate: '操作',
    Edit: '编辑',
    Delete: '删除',
    CreateTask: '创建任务',
    newProject: '新建项目'
  },
  ProjectTask: {
    PublishedTasks: '已发布的任务',
    Project: '项目',
    TotalRewards: '奖励总额',
    TaskNature: '任务属性',
    PaymentTokensId: 'PaymentTokensId',
    NFTContractAddress: 'NFT合约地址',
    CreateProject: '创建项目',
    CreateABountyTask: '创建赏金任务',
    TaskSubject: '任务主题',
    TaskType: '任务种类',
    Country: '国家/地区',
    ActivityDate: '活动日期',
    TotalReward: '奖励总额',
    TheNumberOfParticipants: '参与者人数',
    AcceptanceCriteria: '验收准则',
    TaskDescribe: '任务描述',
    ContactInformation: '联系方式',
    ConfirmRelease: '确认发布',
    startTime: '开始时间',
    to: '至',
    endTime: '结束时间',
    selectPlaceholder: '请选择',
    tipDialog: '赏金任务提交将进入系统审核状态，无法修改。',
    cancel: '取消',
    confirm: '确认'
  },
  Project: {
    Projects: '项目',
    backDes: '项目',
    CreateProject: '创建项目',
    MyProject: '我的项目',
    ProjectName: '项目名称',
    ProjectType: '项目种类',
    ProjectDescription: '项目描述',
    ProjectURL: '项目URL',
    LOGOUpload: 'Logo上传',
    Next: '下一步',
    Confirm: '确认',
    Yes: '确认',
    Cancel: '取消',
    Remove: '移除'
  },
  Task: {
    CreateABountyTask: '创建赏金任务',
    TaskSubject: '任务主题',
    TotalReward: '奖励总额',
    TaskType: '任务种类',
    TheNumberOfParticipants: '参与者人数',
    TaskDescribe: '任务描述',
    AcceptanceCriteria: '验收准则',
    ActivityDate: '活动日期',
    EstimatedRewardTime: 'Estimated reward time',
    ContactInformation: '联系方式',
    ConfirmRelease: '确认发布',
    selectPlaceholder: '请选择',
    startTime: '开始时间',
    endTime: '结束时间',
    list: {
      countAll: '所有参与者',
      countTobechecked: '待验收',
      countChecked: '已验收'
    },
    taskStatus: {
      temp: '暂存',
      review: '审核中',
      back: '驳回',
      ongoing: '正在进行中',
      upcoming: '即将进行',
      finished: '已完成',
      close: '关闭'
    }
  },
  Proposal: {
    status: {
      all: '全部',
      tobechecked: '待确认',
      checked: '已确认',
      temp: '暂存',
      doing: '进行中',
      unchecked: '未确认',
      payed: '已支付',
      close: '关闭'
    },
    BatchPass: '批量通过',
    BatchNoPass: '批量否决',
    BatchPay: '批量支付',
    Export: '导出',
    SelectAll: '全选',
    CompletionDate: '完成日期:',
    pass: '通过',
    nopass: '否决',
    Pay: '支付',
    dateOfProposal: '提交时间'
  },
  allTip: {
    tip1: '请选择',
    tip2: '请输入解决方案',
    tip3: '请输入完成情况',
    tip4: '搜索中',
    tip5: '请连接钱包',
    tip6: '请上传JPG，PNG或BMP格式的文件',
    tip7: '复制失败',
    tip8: '请输入项目名称',
    tip9: '请选择项目种类',
    tip10: '请输入项目描述',
    tip11: '请选择logo',
    tip12: '请选择任务主题',
    tip13: '请选择任务种类',
    tip14: '请选择活动日期',
    tip15: '请输入奖励总额',
    tip16: '请输入数字',
    tip17: '请输入数字',
    tip18: '请输入数字',
    tip19: '奖励总额必须能被参与者人数整除',
    tip20: '请选择任务属性',
    tip21: '请选择任务描述',
    tip22: '质押取回成功',
    tip23: 'NFT合约地址是必填项',
    tip24: '提交中',
    tip25: '请选择代币类型',
    tip26: '请输入拒绝理由',
    tip27: '两次登录钱包地址不一致',
    tip28: '任务接取成功，请去个人主页-已提交的提案中完成任务并提交提案。'
  }
}
